import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Hero } from "@/components/site/Hero";
import { Problem } from "@/components/site/Problem";
import { EditorialMarquee } from "@/components/site/Marquee";
import { Services } from "@/components/site/Services";
import { Process } from "@/components/site/Process";
import { Team } from "@/components/site/Team";
import { Contact } from "@/components/site/Contact";

const Home = ({ lenisRef, scrollToId }) => {
  const location = useLocation();

  // Scroll to a section if the URL includes a hash (e.g. /#services)
  useEffect(() => {
    if (!location.hash) return;
    const id = location.hash.replace("#", "");
    // Wait a tick so the sections are mounted
    const t = setTimeout(() => {
      const el = document.getElementById(id);
      if (!el) return;
      if (lenisRef?.current) lenisRef.current.scrollTo(el, { offset: -80, duration: 1.4 });
      else el.scrollIntoView({ behavior: "smooth" });
    }, 150);
    return () => clearTimeout(t);
  }, [location, lenisRef]);

  return (
    <main>
      <Hero scrollToId={scrollToId} />
      <Problem />
      <EditorialMarquee />
      <Services />
      <Process />
      <Team />
      <Contact />
    </main>
  );
};

export default Home;
